import { FC } from "react"
import { useTranslation } from "react-i18next"

import { ISummarySection } from "@/types"
import { IListItem } from "components/List/List"
import Summary from "components/Summary/Summary"
import useAssetFields, { AssetField } from "hooks/useAssetFields"
import ConnectedAsset from "models/ConnectedAsset"
import { AssetStep } from "pages/AssetPage/config"
import { useAssetDataContext } from "./AssetDataContext"
import useCopyFeatures from "hooks/useCopyFeatures"

interface IAssetDataFeaturesProps {
    connectedAssets?: ConnectedAsset[]
    copyFeatures?: boolean
}

const AssetDataFeatures: FC<IAssetDataFeaturesProps> = ({
    connectedAssets,
    copyFeatures,
}) => {
    const { t } = useTranslation()
    const { asset, article, pinnable, placement, getEditLink, onEditClick } = useAssetDataContext()
    const { onCopyFeatures } = useCopyFeatures({ asset, article })

    const { getFields } = useAssetFields({
        asset,
        article,
        connectedAssets,
        onCopyFeatures: copyFeatures ? onCopyFeatures : undefined,
        pinnable
    })

    const summaryData: ISummarySection<IListItem>[] = [
        {
            title: t('asset.features'),
            items: getFields([
                AssetField.features,
                AssetField.freightUnits,
                ...placement === "sidebar" ? [AssetField.connectedAssets] : [],
            ]),
            editLink: getEditLink?.(AssetStep.features),
            onEditClick: onEditClick ? () => onEditClick(AssetStep.features) : undefined,
        }
    ]


    return (
        <Summary data={summaryData} />
    )
}

export default AssetDataFeatures
